import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyChargeScheduleSummaryModel } from '../../../../core/models/data/property-charge-schedule-summary.model';
import { CurrencyDisplayPipe } from '../../../../core/pipes/currency/currency.pipe';

@Component({
  selector: 'ms-property-charge-schedule-summary-totals',
  imports: [CommonModule, CurrencyDisplayPipe],
  templateUrl: './property-charge-schedule-summary-totals.component.html',
  styleUrl: './property-charge-schedule-summary-totals.component.scss',
})
export class PropertyChargeScheduleSummaryTotalsComponent {
  public summary = input<PropertyChargeScheduleSummaryModel | undefined>(undefined);
  public isLoading = input<boolean>(false);
}
